import { supabase } from "@/lib/supabase";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function InvoiceTranscriberDownload() {
    const { invoice_id } = useParams()

    useEffect(() => {
        const downloadFile = async () => {
            try {
                const { data: invoice } = await supabase.from('transcribers_payments').select('invoice').eq('id', invoice_id).single(); 

                if (!invoice?.invoice?.path) {
                   alert('Invoice not found or path missing');
                }

                const { data, error } = await supabase.storage
                    .from('transcribers.payments.invoices')
                    .download(invoice?.invoice?.path);

                if (error) {
                    throw error;
                }

                // Create a blob from the data
                const blob = new Blob([data], { type: 'application/pdf' });

                // Create a download link and trigger the download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = invoice?.invoice?.path; // Set a filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Download failed:', error);
            }
        };

        downloadFile();
    }, []);

    return (
        <div></div>
    );
}